<script>
  export let hashbang = false
  import page from "page.js"
  import { setContext, afterUpdate } from "svelte"
  import { current_path } from "../etc/store.js"

  setContext("current_path", current_path)

  //   function navigate(ctx, next) {
  //     alert(`Navigating to: ${ctx.path}`)

  //     $current_path = ctx.path
  //   }
  //   page("/", navigate)
  //   page("/about", navigate)
  //   page("/news", navigate)

  let started = false
  afterUpdate(() => {
    if (!started) {
      started = true
      page("*", (ctx) => {
        $current_path = ctx.path
        console.log("PATH NOT FOUND: " + $current_path)
      })
      page.start({ hashbang })
    }
  })
</script>

<slot />
